import type { ShippingFormFieldsConfig, ShippingFormFieldsDefaultValues } from "@checkout-v2/forms";

export type ShippingFormDataContextValue = {
  initialDefaultValues: ShippingFormFieldsDefaultValues | null;
  formFieldsConfig: ShippingFormFieldsConfig | null;
  isShippingAgeVerificationEnabled: boolean;
  isLoading: boolean;
};
